import { ViewTransition, type ReactNode, type ViewTransitionClassPerType } from "react";

const publicPageTransitionClasses = {
  default: "none",
  "nav-forward": "nav-forward",
  "nav-back": "nav-back",
  "nav-lateral": "nav-lateral",
} satisfies ViewTransitionClassPerType;

export function PublicViewTransition({ children }: { children: ReactNode }) {
  return (
    <ViewTransition update={publicPageTransitionClasses} default="none">
      {children}
    </ViewTransition>
  );
}
